import { MEDIA_QUERIES } from "../utils/breakpoints.js";

export function initProductFunctions() {
    (function () {

        const sections = document.querySelectorAll(".js-pointSection .pointItem");
        const links = document.querySelectorAll(".js-pointSection .pointsSection__anchor__btn");

        if (links.length > 0) links[0].classList.add("is-active");

        let isClicked = false;
        let timeoutId = null;

        links.forEach((link) => {
            link.addEventListener("click", () => {
                isClicked = true;
                clearTimeout(timeoutId);

                // Update active state immediately
                links.forEach((l) => l.classList.remove("is-active"));
                link.classList.add("is-active");

                // Scroll nav container immediately
                const container = link.parentElement;
                if (container) {
                    const scrollLeft = link.offsetLeft - (container.offsetWidth / 2) + (link.offsetWidth / 2);
                    container.scrollTo({
                        left: scrollLeft,
                        behavior: "smooth"
                    });
                }

                // Reset flag after the page finishes scrolling (approx 1s)
                timeoutId = setTimeout(() => {
                    isClicked = false;
                }, 500);
            });
        });

        const observer = new IntersectionObserver(
            (entries) => {
                // Skip update if a button was clicked (programmatic scroll)
                if (isClicked) return;

                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        links.forEach((link) => {
                            link.classList.remove("is-active");
                            if (link.getAttribute("href") === `#${entry.target.id}`) {
                                link.classList.add("is-active");

                                const container = link.parentElement;
                                if (container) {
                                    const scrollLeft = link.offsetLeft - (container.offsetWidth / 2) + (link.offsetWidth / 2);
                                    container.scrollTo({
                                        left: scrollLeft,
                                        behavior: "smooth"
                                    });
                                }
                            }
                        });
                    }
                });
            },
            {
                rootMargin: "-40% 0px -40% 0px",
            },
        );

        sections.forEach((section) => observer.observe(section));
    })();
}
